import { View } from './view';
import { Product } from '../config/product';
import { Translations } from '../config/translations';
import { Config } from '../config';
import { Util } from '../config/utils';

export class SubscriptionView extends View {

    private config: Config = {};
    multiSubContainer: HTMLElement = document.createElement('form');

    setConfig(config: Config) {
        this.config = config;
    }

    shouldDisplayProductsAsRadioButtons(): boolean {
        return this.config &&
            this.config.settings &&
            this.config.settings.displayProductsAsRadioButtons &&
            this.config.settings.displayProductsAsRadioButtons === true;
    }

    renderMultipleProducts(subscriptions: Product[], onPlanChange: any) {
        if (this.shouldDisplayProductsAsRadioButtons()) {
            this.renderProductsAsRadioButtons(subscriptions, onPlanChange);
        } else {
            this.renderProductsAsDropdown(subscriptions, onPlanChange);
        }
    }

    renderProductsAsRadioButtons(subscriptions: Product[], onPlanChange: any) {
        let radioButtons = '';
        let counter = 1;
        for (const subscription of subscriptions) {
            radioButtons +=
                `<div class="df-subscription-radio-btn-group">
                    <input
                        df_product_id="${subscription.dfProductId || ''}"
                        id="${subscription.name}_${subscription.amount}"
                        type="radio"
                        class="df-subscription-radio-btn"
                        name="df-subscription-radio-btn"
                        product_name="${subscription.name}"
                        value="${subscription.id}"
                        data-amount="${subscription.amount}"
                        interval="${subscription.interval}"
                        max-charges="${subscription.maxCharges}"
                        ${counter === 1 ? 'checked' : ''}
                    />
                    <label class="df-subscription-radio-btn-label" for="${subscription.name}_${subscription.amount}">${subscription.name}</label>
                    <span class="df-subscription-radio-btn-total">
                        ${this.formatMoney(subscription.amount.toString(), this.config.settings.currency)}${subscription.interval ? '/' + subscription.interval : ''}
                    </span>
                </div>`;
                counter++;
        }

        this.multiSubContainer.classList.add('hs-form', 'stacked', 'df-f', 'df-f-multiple-subscriptions');
        this.multiSubContainer.innerHTML =
            `<fieldset class="form-columns-1 df-fieldset">
                <div class="field hs-form-field df-field">
                    <label>
                        <span class="df-f-label" data-label="multiple_subscriptions">${Translations.MULTIPLE_SUBSCRIPTIONS}</span>
                        <span class='hs-form-required df-f-label'>*</span>
                    </label>
                    <div id="df_subscriptions" class="input hs-input">
                        ${radioButtons}
                   </div>
                </div>
            </fieldset>`;
        const container = this.getDFContainer();
        container.appendChild(this.multiSubContainer);

        this.addRadioButtonEventListeners(onPlanChange);
    }

    addRadioButtonEventListeners(onPlanChange: any) {
        // Add radio button group events.
        const radioButtonGroupElements = document.querySelectorAll('#df_subscriptions .df-subscription-radio-btn-group');
        radioButtonGroupElements.forEach(element => {
            (element as HTMLInputElement).onclick = (event: Event) => {
                const target = event.target as HTMLElement;
                const radioButton = target.querySelector('input.df-subscription-radio-btn') as HTMLSelectElement;
                if (radioButton) {
                    radioButton.click();
                }
            };
        });

        // Add radio button input events.
        const radioButtonInputElements = document.querySelectorAll('#df_subscriptions input.df-subscription-radio-btn');
        radioButtonInputElements.forEach(element => {
            (element as HTMLInputElement).onchange = (event: Event) => {
                const target = event.target as HTMLSelectElement;
                onPlanChange({
                    name: target.getAttribute('product_name'),
                    planId: target.value
                });
            };
        });


        // Add radio button amount events.
        const radioButtonAmountElements = document.querySelectorAll('#df_subscriptions .df-subscription-radio-btn-total');
        radioButtonAmountElements.forEach(element => {
            (element as HTMLInputElement).onclick = (event: Event) => {
                const target = event.target as HTMLElement;
                const radioButton = (target.parentElement as HTMLElement).querySelector('input.df-subscription-radio-btn') as HTMLSelectElement;
                if (radioButton) {
                    radioButton.click();
                }
            };
        });
    }

    renderProductsAsDropdown(subscriptions: Product[], onPlanChange: any) {
        let options = '';
        for (const subscription of subscriptions) {
            options +=
                `<option
                    df_product_id="${subscription.dfProductId || ''}"
                    name="${subscription.name}"
                    product_name="${subscription.name}"
                    value="${subscription.id}"
                    data-amount="${subscription.amount}"
                    interval="${subscription.interval}"
                    max-charges="${subscription.maxCharges}"
                >
                    ${subscription.name}
                </option>`;
        }

        this.multiSubContainer.classList.add('hs-form', 'stacked', 'df-f', 'df-f-multiple-subscriptions');
        this.multiSubContainer.innerHTML =
            `<fieldset class='form-columns-1 df-fieldset'>
                <div class='field hs-form-field df-field'>
                    <label>
                        <span class='df-f-label' data-label="multiple_subscriptions">${Translations.MULTIPLE_SUBSCRIPTIONS}</span>
                        <span class='hs-form-required df-f-label'>*</span>
                    </label>
                    <div>
                        <select class='input hs-input df-select' id='df_subscriptions'>${options}</select>
                    </div>
                </div>
            </fieldset>`;
        const container = this.getDFContainer();
        container.appendChild(this.multiSubContainer);

        const element = document.querySelector('#df_subscriptions') as HTMLSelectElement;
        element.onchange = (event: Event) => {
            const target = event.target as HTMLSelectElement;
            const option = target.options[target.selectedIndex];
            onPlanChange({
                name: option.getAttribute('product_name'),
                planId: option.value
            });
        };
    }

    preselectDfProductId() {
        const preselectedDfProductId = Util.getUrlParameter('dfpr', window.location.href) || '';
        if (!preselectedDfProductId) {
            return;
        }
        if (this.shouldDisplayProductsAsRadioButtons()) {
            this.preselectRadioButtonDfProductId(preselectedDfProductId);
        } else {
            this.preselectDropdownDfProductId(preselectedDfProductId);
        }
    }

    preselectRadioButtonDfProductId(preselectedDfProductId: string) {
        const dfProductsElement = document.querySelectorAll('#df_subscriptions input[type="radio"]');
        dfProductsElement.forEach(dfProductElement => {
            const dfProductId = dfProductElement.getAttribute('df_product_id') || '';
            if (dfProductId === preselectedDfProductId) {
                (dfProductElement as HTMLInputElement).click();
            }
        });
    }

    preselectDropdownDfProductId(preselectedDfProductId: string) {
        const dfProductsElement = document.querySelector('#df_subscriptions') as HTMLSelectElement;
        const options = dfProductsElement.options as HTMLOptionsCollection;
        for (let i = 0; i < options.length; i++) {
            const dfProductId = options[i].getAttribute('df_product_id') || '';
            if (dfProductId === preselectedDfProductId) {
                dfProductsElement.selectedIndex = options[i].index;
                dfProductsElement.dispatchEvent(new CustomEvent('change', {}));
                break;
            }
        }
    }

    getSelectedProduct () {
        if (this.shouldDisplayProductsAsRadioButtons()) {
            return document.querySelector('input[name="df-subscription-radio-btn"]:checked');
        } else {
            const prods: any = document.getElementById('df_subscriptions');
            if (!prods) {
                return;
            }
            return prods.options[prods.selectedIndex];
        }
    }

    hideForm() {
        this.multiSubContainer.style.display = 'none';
    }

    showForm() {
        this.multiSubContainer.style.display = 'inherit';
    }

}
